import { ReactNode, createContext, useMemo } from 'react';
import { uuidSingleton } from 'components/filter/filters-next/defaults';
import { ConditionalOperator } from 'components/filter/types';

interface IFilterGroupContext {
    groupId?: string;
    showInnerOperator?: boolean;
    showOuterOperator?: boolean;
    defaultOperator?: ConditionalOperator;
}

const FilterGroupContext = createContext<IFilterGroupContext>({});

interface FilterGroupProviderProps extends IFilterGroupContext {
    children: ReactNode;
}
const FilterGroupProvider = (props: FilterGroupProviderProps) => {
    const {
        children,
        showInnerOperator = true,
        showOuterOperator = true,
        groupId = uuidSingleton,
        defaultOperator = 'and',
    } = props;

    const ctx = useMemo(
        () => ({
            showInnerOperator,
            showOuterOperator,
            groupId,
            defaultOperator,
        }),
        [groupId, showInnerOperator, showOuterOperator, defaultOperator],
    );

    return <FilterGroupContext.Provider value={ctx}>{children}</FilterGroupContext.Provider>;
};

export { FilterGroupContext, FilterGroupProvider };
export type { IFilterGroupContext, FilterGroupProviderProps };
